import {ssrLazy} from 'ssr/lazy';

export const StickyLinksLazy = ssrLazy(() => import(/* webpackChunkName: "stickyLinks" */ '.'));
